import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));

export const materialFormSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(100),
  category: z.enum(["raw", "intermediate", "finished", "traded"]),
  requires_shape_size: z.boolean(),
  uom_id: z.string().uuid("Select a UOM"),
  description: optional(),
  batch_prefix: z.string().trim().min(1, "Batch prefix is required").max(10),
  parent_material_id: optional(),
  is_active: z.boolean(),
});

export type MaterialFormValues = z.infer<typeof materialFormSchema>;

export const emptyMaterialForm: MaterialFormValues = {
  name: "",
  category: "raw",
  requires_shape_size: false,
  uom_id: "",
  description: "",
  batch_prefix: "MAT",
  parent_material_id: "",
  is_active: true,
};

export const gradeFormSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(50),
  description: optional(),
  available_processes: optional(),
  is_active: z.boolean(),
});

export type GradeFormValues = z.infer<typeof gradeFormSchema>;

export const emptyGradeForm: GradeFormValues = {
  name: "",
  description: "",
  available_processes: "",
  is_active: true,
};

export const shapeSizeFormSchema = z.object({
  shape: z.enum(["round", "square", "rectangle", "oval", "ellipse", "capsule", "custom"]),
  size_label: z.string().trim().min(1, "Size label is required").max(50),
  od: z.coerce.number().nullable().optional(),
  thickness: z.coerce.number().nullable().optional(),
  width: z.coerce.number().nullable().optional(),
  length: z.coerce.number().nullable().optional(),
  applicable_material_id: z.string().uuid("Select a material"),
  mother_size_id: optional(),
  description: optional(),
  is_active: z.boolean(),
});

export type ShapeSizeFormValues = z.infer<typeof shapeSizeFormSchema>;

export const emptyShapeSizeForm: ShapeSizeFormValues = {
  shape: "round",
  size_label: "",
  od: null,
  thickness: null,
  width: null,
  length: null,
  applicable_material_id: "",
  mother_size_id: "",
  description: "",
  is_active: true,
};

export const uomFormSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, "Code is required")
    .max(10)
    .transform((v) => v.toUpperCase()),
  name: z.string().trim().min(1, "Name is required").max(50),
  is_active: z.boolean(),
});

export type UomFormValues = z.infer<typeof uomFormSchema>;

export const emptyUomForm: UomFormValues = {
  code: "",
  name: "",
  is_active: true,
};
